import React from 'react'
import styled from 'styled-components'

import { Skeleton as BaseSkeleton } from '@sketch/components'
import {
  Separator,
  Section,
  Header,
  HeaderTitle,
  Attribute,
  AttributeColumns,
  AttributeLabel,
  AttributeValue,
} from '../../components'

const LayerContainer = styled.div`
  display: flex;
  align-items: center;
`

const Skeleton = styled(BaseSkeleton)`
  margin-right: 12px;
`

export const InspectorSkeleton = ({ isPage = false }) => (
  <div data-testid="inspector-skeleton">
    <Section>
      <LayerContainer>
        <Skeleton width="36px" height="36px" />
        <Skeleton width="100px" height="15px" />
      </LayerContainer>
    </Section>
    {!isPage && (
      <>
        <Separator />
        <Section>
          <Header>
            <HeaderTitle>Artboard</HeaderTitle>
          </Header>
          <AttributeColumns>
            <Attribute display="block">
              <AttributeLabel>Width</AttributeLabel>
              <AttributeValue>
                <Skeleton width="40px" height="15px" />
              </AttributeValue>
            </Attribute>
            <Attribute display="block">
              <AttributeLabel>Height</AttributeLabel>
              <AttributeValue>
                <Skeleton width="40px" height="15px" />
              </AttributeValue>
            </Attribute>
          </AttributeColumns>
        </Section>
      </>
    )}
  </div>
)
